import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ToggleFullScreenDirective} from './fullscreen/toggle-fullscreen.directive';
import {AccordionAnchorDirective} from './accordion/accordionanchor.directive';
import {AccordionLinkDirective} from './accordion/accordionlink.directive';
import {AccordionDirective} from './accordion/accordion.directive';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {TitleComponent} from '../layout/admin/title/title.component';
import {CardComponent} from './card/card.component';
import {CardToggleDirective} from './card/card-toggle.directive';
import {ModalBasicComponent} from './modal-basic/modal-basic.component';
import {ModalAnimationComponent} from './modal-animation/modal-animation.component';
import {SpinnerComponent} from './spinner/spinner.component';
import { SearchComponent } from './search/search.component';
import { UploadComponent } from './upload/upload.component';
import {FileUploadModule} from 'ng2-file-upload';
import {ClickOutsideModule} from 'ng-click-outside';
import {DataFilterPipe} from './elements/data-filter.pipe';
import { NgSelectModule  } from '@ng-select/ng-select';
import { UiSwitchModule } from 'ng2-ui-switch';

import { AuthInterceptor } from './../services/auth/auth.interceptor';
import { CompaniesService } from './../services/companies/companies.service';
import { BusesService } from '../services/buses/buses.service';
import { TripService } from './../services/trips/trip.service';
import { RoutesDataService } from '../services/routes-data/routes-data.service';
import { UserService } from './../services/users/user.service';
import { DevicesService } from '../services/devices/devices.service';
import { ProvidersService } from '../services/providers/provider.service';
import { DriversService } from '../services/drivers/drivers.service';
import { NautoService } from '../services/nauto/nauto.service';
import { GeolocationsService } from '../services/geolocations/geolocations.service';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { ShipmentService } from '../services/shipments/shipment.service';
import { ConsignmentsService } from '../services/shipments/consignments/consignment.service';
import { AssetTypesService } from '../services/asset-types/asset-types.service';
import { AnalyticsService } from '../services/analytics/analytics.service';
import { CustomersService } from '../services/customers/customers.service';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
    CommonModule,
    GooglePlaceModule,
    NgbModule.forRoot(),
    HttpClientModule,
    PerfectScrollbarModule,
    ClickOutsideModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    UiSwitchModule,
    FileUploadModule
  ],
  exports: [
    NgbModule,
    ToggleFullScreenDirective,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CardToggleDirective,
    HttpClientModule,
    PerfectScrollbarModule,
    TitleComponent,
    CardComponent,
    ModalBasicComponent,
    ModalAnimationComponent,
    SpinnerComponent,
    SearchComponent,
    UploadComponent,
    ClickOutsideModule,
    DataFilterPipe,
    NgSelectModule,
    UiSwitchModule,
    GooglePlaceModule
  ],
  declarations: [
    ToggleFullScreenDirective,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CardToggleDirective,
    TitleComponent,
    CardComponent,
    ModalBasicComponent,
    ModalAnimationComponent,
    SpinnerComponent,
    SearchComponent,
    UploadComponent,
    DataFilterPipe
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    UserService,
    CompaniesService,
    BusesService,
    TripService,
    RoutesDataService,
    DevicesService,
    ProvidersService,
    DriversService,
    NautoService,
    GeolocationsService,
    ConsignmentsService,
    ShipmentService,
    AnalyticsService,
    AssetTypesService,
    CustomersService
  ],
  schemas: [ NO_ERRORS_SCHEMA ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/modules/shared.module.ts